module.exports = __webpack_public_path__ + "static/media/rymindr_original.e7a8c3e9.png";